import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToHash()
    this.hashChangeListener = () => this.scrollToHash()
    window.addEventListener("hashchange", this.hashChangeListener)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.hashChangeListener)
  }

  scrollToHash() {
    const hash = window.location.hash
    if (hash) {
      const element = document.querySelector(hash)
      if (element) {
        // Wait a bit for the page to fully render/Turbo to settle
        setTimeout(() => {
          this.performScroll(element)
        }, 100)
      }
    }
  }

  performScroll(element) {
    const headerOffset = 80 // Adjust based on your sticky header height
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    })
  }
}
